
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-backspace",
  "use": "icon-material-backspace-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-backspace\"><path d=\"M362.63-194.02q-23.81 0-43.58-12.14-19.76-12.14-33.88-31.73L114.02-480l171.15-242.11q14.11-19.46 33.88-31.78 19.77-12.33 43.58-12.33h415.22q28.2 0 48.28 20.09 20.09 20.08 20.09 48.28v435.7q0 28.1-20.09 48.12-20.08 20.01-48.28 20.01zm415.22-68.13v-435.7zm-426.26 0h426.26v-435.7H351.63L199.07-480zM452.3-327.2l107.94-107.69L668.17-327.2l45.87-45.87L605.35-480l106.69-106.93-45.87-46.11-105.93 107.93L452.3-633.04l-46.1 46.11L515.13-480 406.2-373.07z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-backspace"/>
                </svg>
            );
        };

        Icon.id = "icon-material-backspace";

        export default Icon;
    